import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TimeRangePickerComponent } from './time-range-picker.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { SharedDirectiveModule } from '@railmybox/shared/directive';

@NgModule({
  declarations: [TimeRangePickerComponent],
  imports: [CommonModule, FlexLayoutModule, SharedDirectiveModule, FormsModule, NgxMaskDirective, NgxMaskPipe],
  exports: [TimeRangePickerComponent],
  providers: [provideNgxMask()],
})
export class TimeRangePickerModule {}
